import { Component, OnInit } from '@angular/core';
import { NgxQrcodeElementTypes, NgxQrcodeErrorCorrectionLevels } from '@techiediaries/ngx-qrcode';
import { Router, ActivatedRoute } from '@angular/router';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { first } from 'rxjs/operators';

import { AuthenticationService } from '../_services';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { NgxSpinnerService } from 'ngx-spinner';
import { Title } from '@angular/platform-browser';
@Component({
  selector: 'app-test2',
  templateUrl: './test2.component.html',
  styleUrls: ['./test2.component.scss']
})
export class Test2Component implements OnInit {
  elementType = NgxQrcodeElementTypes.URL;
  correctionLevel = NgxQrcodeErrorCorrectionLevels.HIGH;
  value = 'https://app.stgdrive.com/';
  RedirectURL = 'http://192.168.1.32:4200/user/reset';
  loginForm: any;
  resetForm: any;

  resetFormShow:boolean =false;
    loading = false;
    submitted = false;
    error = '';
    submittedResetForm: boolean;
    messageErrorReset: any;
    messageSuccessReset: any;
    showerror: any;

    constructor(
        private formBuilder: FormBuilder,
        private route: ActivatedRoute,
        private router: Router,
        private http: HttpClient,
        private authenticationService: AuthenticationService,
        private spinner: NgxSpinnerService,
        private titleService:Title
    ) { 
        // redirect to home if already logged in
        if (this.authenticationService.currentUserValue) { 
            this.router.navigate(['/admin/device']);
        }
    }

    ngOnInit() {
        this.loginForm = this.formBuilder.group({
            username: ['', Validators.required],
            password: ['', Validators.required]
        });

        this.resetForm = this.formBuilder.group({
            user_input: ['', Validators.required],
            redirectTo: []
        });
    }

    resetPassword(){
        this.resetFormShow =true
       
        this.loginForm.reset();
        this.loginForm.invalid =false
        this.resetForm.invalid =false
        this.submittedResetForm = false;
    }

    ReturnButtonSignIn(){
        this.resetFormShow =false
       
        this.resetForm.reset();
        this.showerror =300
        this.loginForm.invalid =false
        this.resetForm.invalid =false
        this.submittedResetForm = false;
    }
    // convenience getter for easy access to form fields
    get f() { return this.loginForm.controls; }
    get r() { return this.resetForm.controls; }
    onSubmit() {
        this.submitted = true;

        // stop here if form is invalid
        if (this.loginForm.invalid) {
           
            return;
        }
        this.spinner.show();
        this.loading = true;
        this.authenticationService.login(this.f.username.value, this.f.password.value)
            .pipe(first())
            .subscribe({
                next: () => {
                    
                    if (this.authenticationService.currentUserValue.role === 'User') {
                        localStorage.removeItem('currentAdmin');
                       
                        // get return url from route parameters or default to '/'
                        const returnUrl = this.route.snapshot.queryParams['returnUrl'] || '/user/vehicule';
                       
                        localStorage.setItem('startDateValue',new Date().toString())
                        localStorage.setItem('endDateValue',new Date().toString())
                        window.location.href= '/user/vehicule'
                        this.loading = false;
                        this.spinner.hide();
                    } else if (this.authenticationService.currentUserValue.role === 'Admin'){
                        
                        // get return url from route parameters or default to '/'
                        const returnUrl = this.route.snapshot.queryParams['returnUrl'] || '/admin/device';
                        document.getElementById('favicon').setAttribute('href', 'https://app.stgdrive.com/assets/1.16:85/ctx/images/custom/stg/favicon.ico');
                        this.titleService.setTitle("STG DRIVE");
                       
                        window.location.href= '/admin/device'
                        this.loading = false;
                        this.spinner.hide();
                    }
                 
            
                },
                error: error => {
                    this.error = error;
                    this.loading = false;
                    this.spinner.hide();
                }
            });
    }


    onResetPassword(){
        this.submittedResetForm = true;

        // stop here if form is invalid
        if (this.resetForm.invalid) {
             
            return;
        }
        this.loading = true;
        
        this.spinner.show();
        this.loading = true;
        this.http.post(environment.apiUrl+'/users/password/forgotten', this.resetForm.value).subscribe(data => {
            
             
            var resp:any = data
         
            if(resp.status ==500){
                this.showerror =500
               this.messageErrorReset = resp.message
              
               this.loading = false;
               this.spinner.hide();
            }else {
                this.showerror =200
                this.messageSuccessReset = resp.message
                this.loading = false;
                this.spinner.hide();
            }
})
    }

}
